import { type AxiosRequestConfig } from 'axios';

import {
  IDefaultClientDTO,
  type IThrowsError,
} from '@gbs-monorepo-packages/common';

import {
  type IPaginationMetaProps,
  type IPaginationResponseData,
  type IResponseData,
  api,
} from './api';
import { type IClientFileDTO } from './documents';

export interface IClientDTO extends IDefaultClientDTO {
  agencyName?: string;
  clientFile?: IClientFileDTO;
  employeeCount: number;
  name: string;
}

export interface IPaginationCompaniesDTO {
  data: IClientDTO[];
  meta: IPaginationMetaProps;
}
export interface IGetCompaniesProps {
  page: number;
  limit: number;
  filter: string;
  all?: boolean;
}

export interface IGetAgenciesExcludingIdProps {
  clientId: string;
  page: number;
  limit: number;
  filter: string;
}

export interface IGetAllAgenciesProps {
  page: number;
  limit: number;
  filter: string;
}

export interface IPaginationAgenciesDTO {
  data: IClientDTO[];
  meta: IPaginationMetaProps;
}

export const getCompanies = async (
  { page, limit, filter, all = false }: IGetCompaniesProps,
  config?: AxiosRequestConfig
): Promise<IPaginationCompaniesDTO> => {
  const result = await api
    .get<IPaginationResponseData<IClientDTO[]>>(
      `api/companies/?page=${all ? 1 : page}&limit=${
        all ? 9999 : limit
      }&filter=${all ? '' : encodeURIComponent(filter)}`,
      config
    )
    .then((resp) => resp.data)
    .catch((err) => {
      throw err;
    });

  return result;
};

export type IGetClientByIdDTO = Pick<IClientDTO, 'id'>;

export const getClientById = async ({
  id,
}: IGetClientByIdDTO): Promise<IClientDTO> => {
  const result = await api
    .get<IResponseData<IClientDTO>>(`api/companies/${String(id)}`)
    .then((resp) => resp.data.data)
    .catch((err) => {
      throw err;
    });

  return result;
};

export const getAgenciesList = async (
  { page, limit, filter }: IGetAllAgenciesProps,
  config?: AxiosRequestConfig
): Promise<IPaginationAgenciesDTO> => {
  const result = await api
    .get<IPaginationResponseData<IClientDTO[]>>(
      `api/companies/agencies?page=${page}&limit=${limit}&filter=${encodeURIComponent(
        filter
      )}`,
      config
    )
    .then((resp) => resp.data)
    .catch((err: IThrowsError) => {
      throw err;
    });

  return result;
};

export const getAgenciesExcludingId = async (
  { clientId, page, limit, filter }: IGetAgenciesExcludingIdProps,
  config?: AxiosRequestConfig
): Promise<IPaginationAgenciesDTO> => {
  const result = await api
    .get<IPaginationResponseData<IClientDTO[]>>(
      `api/companies/agencies/${clientId}?page=${page}&limit=${limit}&filter=${encodeURIComponent(
        filter
      )}`,
      config
    )
    .then((resp) => resp.data)
    .catch((err: IThrowsError) => {
      throw err;
    });

  return result;
};
